module.exports = __webpack_public_path__ + "static/media/AMR.ecf28ff0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/AMR.svg
// module id = 1698
// module chunks = 17